import { render } from "./ThRules.vue?vue&type=template&id=e09fc944&scoped=true"
const script = {}

import "./ThRules.vue?vue&type=style&index=0&id=e09fc944&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e09fc944"

export default script